module.exports = __webpack_public_path__ + "static/img/gold3.14b607ef.webp";